<template>
    <div class="display-card-container">
        <div
            class="display-card d-flex flex-column justify-content-between product-card card-height"
        >
            <div class="display-card-header card-header-height dark d-flex">
                <h3 class="align-self-center">
                    {{ headerText }}
                </h3>
            </div>
            <div class="display-card-body card-body-size">
                <slot />
            </div>
            <div class="product-card-footer">
                <StockLevelMessage
                    :stockLevels="product.StockLevels"
                />
                <button
                    class="display-card-button outline"
                    @click="$emit('moreInfo', id)"
                >
                    <i class="fas fa-info-circle" />
                    &nbsp;More info
                </button>
                <button
                    v-if="selected && !freeTextCta"
                    class="display-card-button primary"
                    @click="$emit('change', id)"
                >
                    <i class="fas fa-pen-square" />
                    &nbsp;Change {{ selectorFor }}
                </button>
                <button
                    v-if="!selected && !freeTextCta"
                    class="display-card-button primary btn"
                    :class="isOutOfStock ? 'btn-disabled' : ''"
                    :disabled="isOutOfStock"
                    @click="$emit('select', id)"
                >
                    <i class="fa fa-plus-square" />
                    &nbsp;Select {{ selectorFor }}
                </button>
                <button
                    v-if="freeTextCta"
                    class="display-card-button primary btn"
                    :class="isOutOfStock ? 'btn-disabled' : ''"
                    :disabled="isOutOfStock"
                    @click="$emit('select', product)"
                >
                    <i
                        v-if="callToActionIconClass"
                        :class="callToActionIconClass"
                    />
                    &nbsp;{{ callToAction }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import StockLevelMessage from "../../shared/components/StockLevelMessage";
import { isFeatureEnabled, featureNames } from "../utils/features";

export default {
    name: "ProductCard",
    components: {
        StockLevelMessage
    },
    props: {
        selected: {
            type: Boolean,
            default: false
        },
        selectorFor: {
            type: String,
            required: true
        },
        freeTextCta: {
            type: Boolean,
            default: false
        },
        callToAction: String,
        callToActionIconClass: String,
        headerText: String,
        id: [Number, String],
        product: Object
    },
    computed: {
        isOutOfStock() {
            return this.product.StockLevels === 0;
        },
        isStockLevelsEnabled() {
            return isFeatureEnabled(featureNames.STOCKLEVELS);
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../Presentation/Nop.Web/Themes/MascomTheme/Content/sass/app/variables";

.card-height {
    height: 100%;
}

.product-card-footer {
    border-bottom-left-radius: $border-radius;
    border-bottom-right-radius: $border-radius;
    width: 100%;
    padding: 20px 15px;
    background-color: $light;

    .btn-disabled {
        cursor: not-allowed;
    }
}

.card-header-height {
    height: 100px;
}

.card-body-size {
    height: 100%;
    width: 100%;
}
</style>
